export default {
    header: () => import(/* webpackChunkName: "mod-header" */ './modules/header'),
    'scroll-top': () => import(/* webpackChunkName: "mod-scroll-top" */ './modules/scroll-top'),
    'background-color': () => import(/* webpackChunkName: "mod-background-color" */ './modules/background-color'),
    video: () => import(/* webpackChunkName: "mod-video" */ './modules/video'),
    'gallery-slider': () => import(/* webpackChunkName: "mod-gallery-slider" */ './modules/gallery-slider'),
    testimonials: () => import(/* webpackChunkName: "mod-testimonials" */ './modules/testimonials'),
    'parallax-parent': () => import(/* webpackChunkName: "mod-parallax-parent" */ './modules/parallax-parent'),
};
